import { __extends } from "tslib";
/**
 * Created by Dominika.Grabowska on 2016-09-09.
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import imageTemplate from '../template/image.hbs';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSImageComponent class
 */
var templateObject = {
    defaultTemplate: imageTemplate,
};
var BSSImageComponent = /** @class */ (function (_super) {
    __extends(BSSImageComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSImageComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        _this._componentVersion = '@@name ver. @@version';
        logger.info('ImageComponent:  => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox);
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        _this._loadingImg();
        return _this;
    }
    /**
     * @desc load img and publish event
     * @emits {$imgEvent-$ENTITY-INSTANCE-ID} emit event when img is loaded
     * @private
     */
    BSSImageComponent.prototype._loadingImg = function () {
        var _this = this;
        logger.info('ImageComponent: ' +
            this._config.componentId +
            ' => function : _loadingImg');
        var $image = this._componentTemplate.find('.bss-image');
        if (this._config.imgEvents) {
            if ($image) {
                var self_1 = this;
                this._toolbox.$($image).on('load', function () {
                    for (var i = 0; i < _this._config.imgEvents.length; i++) {
                        self_1._eventManager.publish(self_1._config.imgEvents[i] + '-' + self_1._config.entityInstanceId, 'bss-image-component');
                    }
                });
            }
        }
    };
    /**
     *
     * @public method
     * @desc destroys infohint and call super method
     */
    BSSImageComponent.prototype.destroy = function () {
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    /**
     * @desc fires super method and set image attributes
     * @param {Object} [bindValuesObj=null] bindValuesObj - data, 'texts' || 'resultData'
     * @param {String} [dataType=null] dataType - type of data, 'texts' || 'resultData'
     * @private
     */
    BSSImageComponent.prototype._bindData = function (bindValuesObj, dataType) {
        if (bindValuesObj === void 0) { bindValuesObj = null; }
        if (dataType === void 0) { dataType = null; }
        logger.info('ImageComponentt: ' +
            this._config.componentId +
            ' => function : _bindData | Params', bindValuesObj, dataType);
        _super.prototype._bindData.call(this, bindValuesObj, dataType);
        this._setImageAttr();
    };
    /**
     * @desc Set image src and alt base ond data from component config (data can be from resultData or texts)
     * @private
     */
    BSSImageComponent.prototype._setImageAttr = function () {
        logger.info('ImageComponent: ' +
            this._config.componentId +
            ' => function : _setImageAttr');
        if (this._config.dynamicSrc) {
            this._setDynamicImgSrc();
        }
        this._imageSrcTag = this._componentTemplate.find('.bss-image-src value');
        if (!this._imageSrcTag.length) {
            this._imageSrcTag = this._componentTemplate.find('.bss-image-src');
        }
        this._imageAltTag = this._componentTemplate.find('.bss-image-alt value');
        if (!this._imageAltTag.length) {
            this._imageAltTag = this._componentTemplate.find('.bss-image-alt');
        }
        this._image = this._componentTemplate.find('.bss-image');
        var imgUrl = this._imageSrcTag.html();
        if (!imgUrl) {
            imgUrl = this._config.src;
        }
        if (imgUrl && imgUrl.match('@protocol@')) {
            imgUrl = imgUrl.replace('@protocol@', location.protocol + '//');
        }
        if (this._isValidImgUrl(imgUrl)) {
            this._image.attr('src', imgUrl);
        }
        this._image.attr('alt', this._imageAltTag.html());
    };
    /**
     * @desc Set dynamic img src, depends on breakpoint. If breakpoint < xs then "_xs" is added before img extension.
     * @private
     */
    BSSImageComponent.prototype._setDynamicImgSrc = function () {
        logger.info('ImageComponent: ' +
            this._config.componentId +
            ' => function : _setDynamicImgSrc');
        if (this._config.dynamicSrc && this._resolution.getCurrent() === 'xs') {
            this._config.src = this._config.dynamicSrc.replace(/.([^.]*)$/, '_xs.$1');
        }
        else {
            this._config.src = this._config.dynamicSrc;
        }
    };
    /**
     * @desc check if image url is a valid image link
     * @param {String} url image url
     * @private
     */
    BSSImageComponent.prototype._isValidImgUrl = function (url) {
        if (typeof url !== 'string')
            return false;
        return !!url.match(/^http.*\.(jpg|jpeg|gif|png|tiff|bmp)$/gi);
    };
    return BSSImageComponent;
}(BSSAbstractComponent));
export default BSSImageComponent;
